import { apiRequest } from "../../actions/api";

import{
    GETBOOK,
    GETBOOK_SUCCESS,
    GETBOOK_ERROR,
    getBookSuccess,
    getBookError,
    setBook,

    GETBOOKDETAILS,
    GETBOOKDETAILS_SUCCESS,
    GETBOOKDETAILS_ERROR,
    getBookdetailsSuccess,
    getBookdetailsError,
    setBookdetails,

    GETPAYMENT,
    GETPAYMENTSUCCESS,
    GETPAYMENTERROR,
    getBookPaymentDetailsSuccess,
    getBookPaymentDetailsError,
    setBookPaymentDetails,

    BOOKPAYMENTPROCESS,
    BOOKPAYMENTSUCCESS,
    BOOKPAYMENTERROR,
    bookPaymentProcess,
    bookPaymentSuccess,
    bookPaymentError,


    BOOKCOMPLETE,
    BOOKCOMPLETESUCCESS,
    BOOKCOMPLETEERROR,
    bookComplete,
    bookCompleteSuccess,
    bookCompleteError,

    BOOKUSERDETAILS,
    BOOKUSERDETAILSSUCCESS,
    BOOKUSERDETAILSERROR,
    booksUserDetails,
    bookUserDetailsSuccess,
    bookUserDetailsError,
    setShippingCharges,

    GETTEMPLEDETAILS,
    GETTEMPLEDETAILS_SUCCESS,
    GETTEMPLEDETAILS_ERROR,
    getTempleDetailsSuccess,
    getTempleDetailsError,
    setTempleDetails



}from "../../actions/book";

export const getallbooks = ({ dispatch }) => (next) => (action) => {
    next(action);
    if (action.type === GETBOOK) {
        dispatch(
            apiRequest(
                "GET",
                "apiCall.php?apicall=bookList",
                action.payload,
                null,
                getBookSuccess,
                getBookError,
                false,
                "['Book']"
            )
        );

    }
};

export const progressGetBook = ({ dispatch }) => (next) => (action) => {
    next(action);

    if (action.type === GETBOOK_SUCCESS) {
        dispatch(setBook(action.payload.data));
    }

    if (action.type === GETBOOK_ERROR) {

    }
}


export const getallbookdetails = ({ dispatch }) => (next) => (action) => {

    next(action);

    if(action.type === GETBOOKDETAILS) {
        dispatch(
            apiRequest(
                "GET",
                "apiCall.php?apicall=bookDetails&BookID=" + action.payload,
                null,
                null,
                getBookdetailsSuccess,
                getBookdetailsError,
                false,
                "['BookDetails']"
            )
        )
    }

}

export const progressBookDetails = ({dispatch}) => (next) => (action) => {

    
    next(action);

    if(action.type === GETBOOKDETAILS_SUCCESS) {
        var data = action.payload.data[0];
        dispatch(setBookdetails(data));

    }

    if( action.type === GETBOOKDETAILS_ERROR) {

    }

}

export const getBookPaymentDetails = ({ dispatch }) => (next) => (action) => {
    next(action);

    if (action.type === GETPAYMENT) {
        dispatch(
            apiRequest(
                "GET",
                "apiCall.php?apicall=bookPaymentDetails",
                action.payload,
                null,
                getBookPaymentDetailsSuccess,
                getBookPaymentDetailsError,
                false,
                ['PAYMENTDETAILS']
            )
        )
    }

}

    export const setBookPayment = ({ dispatch }) => (next) => (action) => {
        next(action);

            if (action.type === GETPAYMENTSUCCESS) {
                var data = action.payload.data;
                dispatch(setBookPaymentDetails(data));
            }
            if (action.type === GETPAYMENTERROR) {
            }

    }


        export const bookProcess = ({ dispatch }) => (next) => (action) => {
            next (action);
    
            if (action.type === BOOKPAYMENTPROCESS) {
                dispatch(
                    apiRequest(
                        "POST",
                        "apiCall.php?apicall=bookPayment",
                        null,
                        action.payload,
                        bookPaymentSuccess,
                        bookPaymentError,
                        false,
                        ['PAYMENTDETAILS']
                    )
                )
            }
        }


          export const bookPayment = ({ dispatch }) => (next) => (action) => {
                next(action);
            
                if (action.type === BOOKPAYMENTSUCCESS) {
                    var data = action.payload.data;
                    dispatch((data));
                }
                if (action.type === BOOKPAYMENTERROR) {
                }
            }

            export const bookFlow = ({dispatch}) => (next) => (action) => {
                    next(action);
            
                    if (action.type === BOOKCOMPLETE) {
                        dispatch(
                            apiRequest(
                                "POST",
                                "apiCall.php?apicall=bookPaymentCreation",
                                null,
                                action.payload,
                                bookCompleteSuccess,
                                bookCompleteError,
                                false,
                                ['BOOKPAYMENTDETAILS']
                            )
                        )
                    }
                }
            
                export const bookFlowProcess = ({dispatch}) => (next) => (action) => {
                    next(action);
                
                    if (action.type === BOOKCOMPLETESUCCESS) {
                
                    }
                
                    if (action.type === BOOKCOMPLETEERROR) {
                    }
                }

                export const bookUserData = ({dispatch}) => (next) => (action) => {
                    next(action);
                
                    if (action.type === BOOKUSERDETAILS) {
                        dispatch(
                            apiRequest(
                                "POST",
                                "apiCall.php?apicall=shipmentCharges",
                                null,
                                action.payload,
                                bookUserDetailsSuccess,
                                bookUserDetailsError,
                                false,
                                ['BOOKUSERDETAILS']
                            )
                        )
                    }
                }

                export const bookUserDataProcess = ({dispatch}) => (next) => (action) => {
                    next(action);
                
                    if (action.type === BOOKUSERDETAILSSUCCESS) {
                        var data = action.payload.Data;
                        dispatch(setShippingCharges(data));
                    }
                
                    if (action.type === BOOKUSERDETAILSERROR) {
                        // Handle error if needed
                    }
                }

                                
                export const getTempleDetails = ({dispatch}) => (next) => (action) => {
                    next(action);

                    if (action.type === GETTEMPLEDETAILS) {
                        dispatch(
                            apiRequest(
                                "GET",
                                "apiCall.php?apicall=templeDetails",
                                null,
                                null,
                                getTempleDetailsSuccess,
                                getTempleDetailsError,
                                false,
                                ['TEMPLEDETAILS']
                            )
                        )
                    }
                }

                export const progressTempleDetails = ({dispatch}) => (next) => (action) => {
                    next(action);

                    if (action.type === GETTEMPLEDETAILS_SUCCESS) {
                        dispatch(setTempleDetails(action.payload.Data));
                    }

                    if (action.type === GETTEMPLEDETAILS_ERROR) {
                    }
                }




export const bookmodel = [
    getallbooks,
    progressGetBook,
    getallbookdetails,
    progressBookDetails,
    getBookPaymentDetails,
    setBookPayment,
    bookProcess,
    bookPayment,
    bookFlow,
    bookFlowProcess,
    bookUserData,
    bookUserDataProcess,
    getTempleDetails,
    progressTempleDetails

]